import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  relativesLength: 0,
  relatives: [],
}

export default function relativesReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_RELATIVES:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_RELATIVES:
      return {...state, saveLoader: action.payload}
    case actions.GET_RELATIVES:
      return {...state, relatives: action.payload.relatives, relativesLength: action.payload.relativesLength}
    default:
      return state
  }
}